// HTTP配置
export const HTTP_CONFIG = {
  // SERVER_ADDR: 'http://47.93.132.27:8000',
  // API_BASE_URL: 'http://47.93.132.27:8000/',
  // API_laundry_URL: 'http://47.93.132.27:8010/'
  SERVER_ADDR: '/api',
  API_BASE_URL: '/api/',
  API_laundry_URL: '/'
};
